"use client";

import React, { createContext, useContext, useState, useEffect } from 'react';

// Initialize with the appropriate shape
const ShareDialogContext = createContext({
  triggerShareDialog: () => {},
  resetTrigger: () => {},
  trigger: false,
});

export function ShareDialogProvider({ children } : { children: React.ReactNode }) {
  const [trigger, setTrigger] = useState(false);

  const triggerShareDialog = () => setTrigger(true);
  const resetTrigger = () => setTrigger(false);

  return (
    <ShareDialogContext.Provider value={{ triggerShareDialog, resetTrigger, trigger }}>
      {children}
    </ShareDialogContext.Provider>
  );
}

export function useShareDialog() {
  return useContext(ShareDialogContext);
}

